import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Item = {
  kind: string;
  id: string;
  headline: string;
  state?: string;
  occurredAt: string;
};

export default function InboxPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ items: Item[] }>("/api/v1/tenant/inbox");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("inbox.title")}</h1>
      <DataTable
        rows={data?.items ?? null}
        loading={loading}
        error={error}
        empty={t("inbox.empty")}
        columns={[
          { header: t("inbox.col.kind"), render: (r) => r.kind.replace("_", " ") },
          { header: t("inbox.col.headline"), render: (r) => r.headline || "—" },
          { header: t("inbox.col.state"), render: (r) => r.state ?? "—" },
          {
            header: t("inbox.col.when"),
            render: (r) => new Date(r.occurredAt).toLocaleString(),
          },
        ]}
      />
    </div>
  );
}
